const docEl = document.documentElement
const dpr = window.devicePixelRatio || 1
const screenWidth = docEl.clientWidth
const fontSize = (100 * screenWidth) / 750
docEl.style.fontSize = fontSize + 'px'
